import { useAuthStore } from "@/store/authStore";
import Forbidden from "@/pages/Forbidden";

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute = ({ children }: AdminRouteProps) => {
  const user = useAuthStore((state) => state.user);

  if (!user?.is_admin) {
    return <Forbidden />;
  }

  return <>{children}</>;
};

export default AdminRoute;
